const development = {
    // Dev env realtime database
    url: 'http://localhost:3000/api',
    //url: 'https://staging.kidsmatin.com/api',
    timeout: 40000
 };
 
 const staging = {
    // Staging env realtime database
    url: 'https://staging.kidsmatin.com/api',
    timeout: 40000
 };
 
 const production = {
    // Dev env realtime database
    //url: 'https://www.kidsmatin.com/api',
    url: 'https://kidsmatin.com/api',
    timeout: 40000
 };
 
 let axiosConfig = development;
 if( process.env.REACT_APP_ENV !== undefined && ['development', 'staging', 'production'].includes(process.env.REACT_APP_ENV) ) {
   if( process.env.REACT_APP_ENV === 'production' ) axiosConfig = production;
   else if( process.env.REACT_APP_ENV === 'staging' ) axiosConfig = staging;
 }
 
 export default axiosConfig;


// WEBPACK FOOTER //
// ./src/conf/axios.js